import {SearchInputMobileDefaultBox} from "./search-input-mobile.default.box";
import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {SearchInputMobileCasino777Box} from "./search-input-mobile.casino777.box";
import { SearchInputMobileMrGreenCisBox } from "./search-input-mobile.mrgreenCis.box";

export const SearchInputMobileBox = styledByTheme(SearchInputMobileDefaultBox)
    .forCasino777(SearchInputMobileCasino777Box)
    .forMrGreenCis(SearchInputMobileMrGreenCisBox)
    .apply();